export default __webpack_public_path__ + "static/media/edit_category.dfba9f0c.svg";